/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react"
import { useAuth } from "react-oidc-context"
import { useNavigate, useSearchParams } from "react-router-dom"
import { useAppDispatch } from '../stores/hooks'
import logoFull from '../images/logo-full.png'
import { setSession } from "../stores/sessionSlice"
import * as FeedbackService from "../services/FeedbackService";

const LoginRouter = () => {
  const auth = useAuth();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [isAuthenticated, setIsAuthenticated] = useState(false)
  const [error, setError] = useState(false)
  const [countDown, setCountDown] = useState<number | undefined>()
  const dispatch = useAppDispatch()

  const redirectingTo = (): string => localStorage.getItem('referer') || '/feedbacks'

  useEffect(() => {
    if (isAuthenticated) {
      try {
        const result = FeedbackService.insertIdCognitoFeedback();

      } catch (error) {
        console.error("Erro ao chamar insertIdCognitoFeedback:", error);
      }}
    setCountDown(3)
  }, [isAuthenticated])

  useEffect(() => {
    if (countDown) countDownFn()

    if (countDown === 0) {
      navigate(redirectingTo())
      localStorage.removeItem('referer')
    }
  }, [countDown])

  useEffect(() => {
    if (searchParams.get('error_description')) {
      setError(true)
    }
  })

  useEffect(() => {
    if (auth.isAuthenticated && auth.user) {
      setIsAuthenticated(true)

      const code = searchParams.get("code")
      const state = searchParams.get("state")
      const sessionData = {
        id: auth.user?.profile['cognito:username'],
        name: auth.user?.profile.name,
        email: auth.user?.profile.email,
        picture: auth.user?.profile.picture,
        token_use: auth.user?.profile.token_use,
        exp: auth.user?.profile.exp,
        id_token: auth.user?.id_token,
        access_token: auth.user?.access_token,
        refresh_token: auth.user?.refresh_token,
        code: code,
        state: state
      } as ISession

      dispatch(setSession(sessionData))


      localStorage.setItem('sessionData', JSON.stringify(sessionData))
      localStorage.setItem('idToken', sessionData.id_token)
      localStorage.setItem('accessToken', sessionData.access_token)
      localStorage.setItem('refreshToken', sessionData.refresh_token)
    }


  }, [auth.isAuthenticated])

  const countDownFn = (): void => {
    setTimeout(() => {
      setCountDown(((countDown as number) - 1))
    }, 1000)
  }

  const renderCountDown = (): React.JSX.Element => {
    if (error || !isAuthenticated) return <></>

    return (
      <div className="d-flex flex-column w-50 align-items-center justify-content-center py-5">
        <p>Redirecionando para {redirectingTo()}</p>
        <p>Em {countDown} segundo{countDown === 1 ? '' : 's'}...</p>
      </div>
    )
  }

  const renderUserInfo = (): React.JSX.Element => {
    if (error || auth.isAuthenticated || auth.user) return <></>

    return (
      <div className="d-flex w-50 align-items-center justify-content-center py-5">
        Aguardando informações de autenticação...
      </div>
    )
  }

  const renderError = (): React.JSX.Element => {
    if (!error) return <></>

    return (
      <div className="alert alert-danger mt-5">
        <h4>Erro na autenticação</h4>
        <p>{searchParams.get('error')}</p>
        <p>{searchParams.get('error_description')}</p>
        <p className="m-0">{searchParams.get('state')}</p>
      </div>
    )
  }

  return (
    <div>
      <div className="d-flex flex-column justify-content-center align-items-center vh-100">
        <img src={logoFull} className="logo-full d-block mb-5" alt="Feedback Canvas Logo" />
        <h1>Bem vindo ao Feedback Canvas</h1>
        {renderCountDown()}
        {renderUserInfo()}
        {renderError()}
      </div>
    </div>
  )
}

export default LoginRouter
